const processOrderPackProducts = (headers, invoiceItems, payload, transData, restOrder, type = 0) => {
  let getHeaders = ''
  let getContent = ''
  for (let i = 0; i < headers.length; i++) {
    if (headers[i].value !== 'dg') {
      if (headers[i].value === 'qty' || headers[i].value === 'pickedqty' || headers[i].value === 'rest') getHeaders += `<th class="th-fontsize text-right" width="${headers[i].width}">${headers[i].text}</th>`
      else getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
    }
  }
  for (let j = 0; j < invoiceItems.length; j++) {
    getContent += `<tr class="${j > 0 ? 'comments_border_remove' : ''}">`
    for (let i = 0; i < headers.length; i++) {
      if (invoiceItems[j].isparent) {
        if (headers[i].value === 'number') {
          getContent += '<td class="th-fontsize" colspan="4"></td>'
        } else if (headers[i].value === 'updatedon') {
          getContent += `<td class="th-fontsize">${invoiceItems[j][headers[i].value] || ''}</td>`
        } else if (headers[i].value === 'deliveredqty' || headers[i].value === 'pickedqty' || headers[i].value === 'rest') {
          getContent += `<td class="th-fontsize text-right">${invoiceItems[j][headers[i].value] || ''}</td>`
        }
      } else {
        if (headers[i].value === 'qty' || headers[i].value === 'pickedqty' || headers[i].value === 'deliveredqty' || headers[i].value === 'rest') {
          getContent += `<td class="th-fontsize text-right">${invoiceItems[j][headers[i].value] || ''}</td>`
        } else if (headers[i].value === 'producttext') {
          getContent += `<td class="th-fontsize">
            ${invoiceItems[j][headers[i].value] || ''}
          </td>`
        } else getContent += `<td class="th-fontsize">${invoiceItems[j][headers[i].value] || ''}</td>`
      }
      if ((headers.length - 1) === i && invoiceItems[j].comments && invoiceItems[j].isrestlastrow) {
        getContent += `<tr class="comments_border_remove"><td></td><td colspan="4" cl>${invoiceItems[j].comments || ''}</td><td colspan="3"></td></tr>`
      }
    }
    getContent += '</tr>'
  }
  return content(getHeaders, getContent, payload, transData, restOrder)
}
const content = (headers, content, payload, transData, restOrder) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
    .comments_border_remove td {
      border-top: none !important;
    }
    tbody tr { page-break-inside:avoid; }
    tbody tr td { word-break: break-word; }
    </style>
  </head>
  <body>
  <div class="container-fluid">
    <br><br>
    <div class="row">
      <div class="col-xs-6" >
        <h4>${transData.customer || ''}: ${payload.customername || ''}</h4>
        <span>${transData.deliveryaddress || ''}: </span>
        <div style="margin-left: 10px;">
          <span>${payload.customeraddress_address || ''}</span><br>
          <span>${payload.customeraddress_address2 || ''}</span><br>
          <span>${payload.customeraddress_postcode || ''} ${payload.customeraddress_city || ''}</span>
        </div>
      </div>
      <div class="col-xs-6">
        <img class="img-responsive pull-right" height="350" width="350" src="${process.env.VUE_APP_IMAGE_URL}/${process.env.VUE_APP_LOGO_NAME}" alt="rotostop">
      </div>
      <div class="col-xs-6">
        <div class="row">
          <div class="col-xs-6 text-left">
            <h4>${restOrder ? `${transData.restorder} ${restOrder}` : ''}</h4>
          </div>
          <div class="col-xs-6 text-right">
            <h4>${transData.confirm}</h4>
          </div>
        </div>
        <hr style="margin: 1px;" />
        <table style="width: 100%">
          <tr>
            <td width="50%">${transData.number}:</td>
            <td width="50%" class="text-right">${payload.number || ''}</td>
          </tr>
          <tr>
            <td>${transData.responsible}:</td>
            <td class="text-right">${payload.responsiblename || ''}</td>
          </tr>
          <tr>
            <td>${transData.contact}:</td>
            <td class="text-right">${payload.contactname || ''}</td>
          </tr>
          <tr>
            <td>${transData.yourreference}:</td>
            <td class="text-right">${payload.yourreference || ''}</td>
          </tr>
          <tr>
            <td>${transData.orderdate}:</td>
            <td class="text-right">${payload.orderdate || ''}</td>
          </tr>
          <tr>
            <td>${transData.deliverydate}:</td>
            <td class="text-right">${payload.deliverydate || ''}</td>
          </tr>
          <tr>
            <td>${transData.shipment}:</td>
            <td class="text-right">${payload.shipmentname || ''}</td>
          </tr>
        </table>
      </div>
      <div class="col-xs-12">
        <table class="table table-condensed" style="width: 100%">
          <tbody>
            <tr>
              ${headers}
            </tr>
            ${content}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>
</html>`)))
export default processOrderPackProducts
